var SiqSpinnerComponent = /** @class */ (function () {
    function SiqSpinnerComponent() {
        this.isRunning = true;
    }
    return SiqSpinnerComponent;
}());
export { SiqSpinnerComponent };
